import React from "react";
import { useRouteError, useLocation, isRouteErrorResponse } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const location = useLocation();
  const { toast } = useToast();

  console.log("Current URL:", location.pathname);
  console.log("Route Error:", error);

  React.useEffect(() => {
    if (isRouteErrorResponse(error)) {
      toast({
        title: "Navigation Error",
        description: `Error accessing ${location.pathname}. Status: ${error.status}`,
        variant: "destructive",
      });
    }
  }, [error, location.pathname, toast]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold">Oops!</h1>
        <p className="text-xl text-muted-foreground">
          {isRouteErrorResponse(error) 
            ? `Page not found: ${location.pathname}`
            : "Something went wrong"}
        </p>
        <div className="flex gap-4 justify-center">
          <Button onClick={() => window.history.back()}>Go Back</Button>
          <Button variant="outline" onClick={() => window.location.href = "/"}>
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export const RouteWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};